// Entry point: mounts the app (src/app) into #app.
import { startApp } from './app';

const app = startApp(document.getElementById('app')!);
if (import.meta.env.DEV) (window as unknown as { __uzApp: unknown }).__uzApp = app;
